import { Sponsors } from "../test/dataset";
import { Link } from "react-router-dom";

export default function SponsersAffiliationsSidebar({hidePadding = false, showRange= {start: 0, end: 8}}) {
    return (<div className={`container mx-auto`}>
        <div className="font-medium leading-tight text-14 text-secondary mb-2">
              Our Sponsors & Affiliations
            </div>
        {/* Sponsors Grid - 3x3 layout with fixed dimensions */}
        <div className="grid grid-cols-1 space-y-2">
          {Sponsors.slice(showRange.start, showRange.end).map((sponsor, i) => (
            <Link
              key={i}
              to={`${sponsor.link}${sponsor.link.includes('?') ? '&' : '?'}utm_source=pharmacywiki&utm_medium=sponsor&utm_campaign=sponsor_affiliation`}
              target="_blank"
              className="group"
            >
              <div className="flex h-full overflow-hidden transition-all duration-300 bg-white border rounded-xl border-white/10 hover:shadow-lg hover:shadow-primary/5 hover:border-primary/20">
                <div className="flex items-center justify-center flex-shrink-0 p-3 bg-gradient-to-r from-gray-50 to-gray-100" style={{ width: '80px' }}>
                  <img
                    src={sponsor.image}
                    alt={sponsor.name}
                    className="object-contain w-full h-12"
                    onError={(e) => {
                      e.target.src = "https://imageplaceholder.net/80x60/f3f4f6/131313?text=Sponsor";
                    }}
                  />
                </div>
                <div className="flex flex-col flex-1 p-3">
                  <div className="font-medium transition-colors text-14 text-secondary group-hover:text-primary">
                    {sponsor.name}
                  </div>
                  <div className="mt-1 text-[12px] font-text text-light-gray/60 line-clamp-6 h-fit">
                    {sponsor.shortDescription}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )
}